import { render, staticRenderFns } from "./CashbackMaster.vue?vue&type=template&id=15dda19b&"
import script from "./CashbackMaster.vue?vue&type=script&lang=js&"
export * from "./CashbackMaster.vue?vue&type=script&lang=js&"
import style0 from "./CashbackMaster.vue?vue&type=style&index=0&id=15dda19b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports